import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FiChevronDown, FiShoppingCart } from "react-icons/fi";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="top-banner">
        <div className="container banner-container">
          <div className="banner-left">
            Get 15% off your first order! <strong>Click here to join.</strong>
          </div>
          <div className="banner-right">
            <strong>Welcome to the Official Petoutlet Store</strong> — Delivery
            Available Across Hong Kong
          </div>
        </div>
      </div>

      <div className="main-header">
        <div className="container header-container">
          <div className="logo-container">
            <Link onClick={toTop} to="/" className="logo-link">
              <img
                src="/brand/petoutlet-logo.svg"
                alt="Petoutlet"
                className="brand-logo"
              />
            </Link>
          </div>

          <nav className="nav-menu">
            <ul className="nav-list">
              <li className="nav-item">
                <Link onClick={toTop} to="/shop" className="nav-link">
                  Sale
                </Link>
              </li>
              <li className="nav-item">
                <Link onClick={toTop} to="/about" className="nav-link">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link onClick={toTop} to="/contact" className="nav-link">
                  Help
                </Link>
              </li>
              <li className="nav-item more-nav-item">
                <details className="more-menu">
                  <summary className="nav-link">
                    More <FiChevronDown className="dropdown-icon" />
                  </summary>
                  <ul className="more-dropdown">
                    <li><Link onClick={toTop} to="/faqs">FAQs</Link></li>
                    <li><Link onClick={toTop} to="/shipping">Shipping Policy</Link></li>
                    <li><Link onClick={toTop} to="/returns">Returns Policy</Link></li>
                    <li><Link onClick={toTop} to="/privacy">Privacy Policy</Link></li>
                    <li><Link onClick={toTop} to="/cookies">Cookie Policy</Link></li>
                    <li><Link onClick={toTop} to="/terms">Terms of Service</Link></li>
                  </ul>
                </details>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            <Link
              onClick={toTop}
              to="/cartpage"
              className="action-btn cart-btn"
              aria-label="Shopping Cart"
            >
              <FiShoppingCart />
              {cartItems && cartItems.length > 0 && (
                <span className="cart-count">{cartItems.length}</span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
